import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, combineLatest, filter, map } from 'rxjs';
import { SalesInsightsDataScope, SalesInsightsFilterValues } from '../models/sales-insights.model';

@Injectable()
export class SalesInsightsDashboardState {
  private filtersSubject = new BehaviorSubject<SalesInsightsFilterValues>({});
  private reloadSubject = new BehaviorSubject<number>(0);
  private changesSubject = new Subject<SalesInsightsDataScope>();
  private customerHealthFlagSubject = new BehaviorSubject<string | null>(null);

  readonly filters$: Observable<SalesInsightsFilterValues> = combineLatest([
    this.filtersSubject,
    this.reloadSubject
  ]).pipe(map(([filters]) => filters));

  get filters(): SalesInsightsFilterValues {
    return this.filtersSubject.value;
  }

  setFilters(filters: SalesInsightsFilterValues): void {
    this.filtersSubject.next(filters);
  }

  reload(): void {
    this.reloadSubject.next(this.reloadSubject.value + 1);
  }

  readonly customerHealthFlag$: Observable<string | null> = this.customerHealthFlagSubject.asObservable();

  get customerHealthFlag(): string | null {
    return this.customerHealthFlagSubject.value;
  }

  setCustomerHealthFlag(flag: string | null): void {
    this.customerHealthFlagSubject.next(flag || null);
  }

  /** Whether the page shows a customer list that a warning tile can filter. */
  hasCustomerList = false;

  notifyChanged(scope: SalesInsightsDataScope): void {
    this.changesSubject.next(scope);
  }

  changes(...scopes: SalesInsightsDataScope[]): Observable<SalesInsightsDataScope> {
    return this.changesSubject.pipe(filter(scope => scopes.includes(scope)));
  }
}
